import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";
import { GeofenceDTO } from "../geofences/Geofence";

const PATH = "geofences";

@Injectable({
  providedIn: "root",
})
export class GeofenceHandlerService {
  constructor(private APIService: ApiService) {}

  getGeofences(
    masterAccountID: number,
    queryParams?: { facility_id?: number[]; page?: number; perPage?: number },
  ) {
    return this.APIService.get(`${PATH}/${masterAccountID}`, {
      params: queryParams,
    });
  }

  getGeofence(masterAccountID: number, geofenceID: number) {
    return this.APIService.get(`${PATH}/${masterAccountID}/${geofenceID}`);
  }

  deleteGeofence(masterAccountID: number, geofenceID: number) {
    return this.APIService.delete(`${PATH}/${masterAccountID}/${geofenceID}`);
  }

  postGeofence(masterAccountID: number, geofenceDTO: GeofenceDTO) {
    return this.APIService.post(`${PATH}/${masterAccountID}`, geofenceDTO);
  }

  putGeofence(masterAccountID: number, geofenceDTO: GeofenceDTO) {
    return this.APIService.put(
      `${PATH}/${masterAccountID}/${geofenceDTO.id}`,
      geofenceDTO,
    );
  }

  getIntersectingGeofences(masterAccountID: number, geofenceID: number) {
    return this.APIService.get(
      `${PATH}/${masterAccountID}/${geofenceID}/intersections`,
    );
  }
}
